import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { skillsData } from "../data";
import Marquee from "react-fast-marquee";
import { useEffect, useState } from "react";

function Skills() {
  const [startMarquee, setStartMarquee] = useState(true);

  // Animation variants - daha hızlı
  const containerVariants = {
    hidden: { opacity: 0.95 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.02,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0.95, y: 5 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.1, // Daha hızlı geçiş
      },
    },
  };

  return (
    <section className="py-20 bg-white" id="skills">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={containerVariants}
          className="max-w-6xl mx-auto"
        >
          <motion.div variants={itemVariants} className="text-center mb-16">
            <span className="text-primary font-medium">What I Do Best</span>
            <h2 className="text-3xl md:text-4xl font-bold text-dark mt-2">
              My Skills & Expertise
            </h2>
            <div className="w-20 h-1 bg-primary mx-auto mt-4 rounded-full"></div>
            <p className="text-gray-600 mt-6 max-w-2xl mx-auto">
              I specialize in modern web development technologies, focusing on
              creating responsive and user-friendly applications.
            </p>
          </motion.div>
        </motion.div>
      </div>

      {/* Full-width Marquee section */}
      <motion.div
        variants={itemVariants}
        className="mb-16 overflow-hidden relative w-full"
        initial={{ opacity: 1 }}
        animate={{ opacity: 1 }}
      >
        <div
          className="absolute left-0 top-0 w-[150px] h-full z-10 pointer-events-none"
          style={{
            background:
              "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
          }}
        ></div>

        <div
          className="absolute right-0 top-0 w-[150px] h-full z-10 pointer-events-none"
          style={{
            background:
              "linear-gradient(270deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
          }}
        ></div>

        <div className="py-10">
          <Marquee speed={40} gradient={false} pauseOnHover={true}>
            <div
              className="flex"
              style={{ gap: "80px", paddingLeft: "40px", paddingRight: "40px" }}
            >
              {skillsData.map((skill, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center"
                  style={{ width: "120px" }}
                >
                  <div className="w-14 h-14 bg-primary/5 rounded-full flex items-center justify-center text-primary shadow-sm">
                    <FontAwesomeIcon icon={skill.icon} className="text-2xl" />
                  </div>
                  <h3 className="text-base font-medium text-gray-800 mt-3 whitespace-nowrap">
                    {skill.name}
                  </h3>
                </div>
              ))}
            </div>
          </Marquee>
        </div>
      </motion.div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
            {skillsData.map((skill, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300"
              >
                <div className="flex items-center mb-3">
                  <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center text-primary mr-3">
                    <FontAwesomeIcon icon={skill.icon} className="text-lg" />
                  </div>
                  <h3 className="font-semibold text-dark">{skill.name}</h3>
                </div>
                <p className="text-gray-600 text-sm">{skill.description}</p>
              </motion.div>
            ))}
          </div>

          <motion.div
            variants={itemVariants}
            className="mt-10 bg-gradient-to-r from-primary to-secondary p-8 md:p-12 rounded-2xl shadow-lg"
          >
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="text-white mb-8 md:mb-0 text-center md:text-left">
                <h3 className="text-2xl md:text-3xl font-bold mb-4">
                  Looking for a skilled developer?
                </h3>
                <p className="text-white/80 max-w-xl">
                  I'm currently available for freelance work or full-time
                  positions. Let's build something amazing together!
                </p>
              </div>
              <a
                href="#contact"
                className="btn bg-white text-primary hover:bg-white/90 font-semibold px-8 py-3 rounded-lg"
              >
                Hire Me
              </a>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="mt-20">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div className="text-center">
                <span className="text-4xl md:text-5xl font-bold text-primary block">
                  2+
                </span>
                <span className="text-gray-600 mt-2 block">
                  Years Experience
                </span>
              </div>
              <div className="text-center">
                <span className="text-4xl md:text-5xl font-bold text-primary block">
                  15+
                </span>
                <span className="text-gray-600 mt-2 block">
                  Projects Completed
                </span>
              </div>
              <div className="text-center">
                <span className="text-4xl md:text-5xl font-bold text-primary block">
                  99%
                </span>
                <span className="text-gray-600 mt-2 block">
                  Client Satisfaction
                </span>
              </div>
              <div className="text-center">
                <span className="text-4xl md:text-5xl font-bold text-primary block">
                  24/7
                </span>
                <span className="text-gray-600 mt-2 block">Support</span>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

export default Skills;
